import { momentDate } from '../dates';
import type { ProgressStep } from './notice-progress';

const day = momentDate;

/** The notice's lifecycle as a track: done steps carry their date, the current one says whose turn it is. */
export function NoticeProgress({ steps }: { steps: ProgressStep[] }) {
  return <ol className="notice-progress" aria-label="Where this notice is">
    {steps.map(step => <li key={step.key} className={`progress-${step.state}`} aria-current={step.state === 'current' ? 'step' : undefined}>
      <span className="progress-mark" aria-hidden="true">{step.state === 'done' ? '✓' : ''}</span>
      <strong>{step.label}</strong>
      {step.state === 'done' && <small>{step.at ? day(step.at) : 'Done'}</small>}
      {step.note && <small className="progress-note">{step.note}</small>}
    </li>)}
  </ol>;
}
